"use strict";
/* global I18n */
Object.defineProperty(exports, "__esModule", { value: true });
var alt_1 = require("../components/alt");
var locales_actions_1 = require("./locales_actions");
var AVAILABLE_LOCALES = ['en', 'de', 'es', 'fr', 'nl', 'ja', 'it'];
var DEFAULT_LOCALE = I18n.defaultLocale;
var LocalesStore = /** @class */ (function () {
    function LocalesStore() {
        this.resetState();
        this.bindListeners({
            handleCurrentLocaleChange: locales_actions_1.default.SET_CURRENT_LOCALE,
        });
    }
    LocalesStore.prototype.handleCurrentLocaleChange = function (locale) {
        this.currentLocale = locale;
    };
    LocalesStore.prototype.resetState = function () {
        this.locales = AVAILABLE_LOCALES;
        this.currentLocale = DEFAULT_LOCALE;
    };
    return LocalesStore;
}());
exports.default = alt_1.default.createStore(LocalesStore, 'LocalesStore');
//# sourceMappingURL=locales_store.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/locales_store.js
// module id = bx5k
// module chunks = 20 21